import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/icon-powered-by.svg'


const _hoisted_1 = { class: "estate-map-body" }
const _hoisted_2 = {
  key: 0,
  class: "title-wr"
}
const _hoisted_3 = {
  key: 0,
  class: "estate-map-body__title"
}
const _hoisted_4 = {
  key: 3,
  class: "estate-map-blocks"
}
const _hoisted_5 = {
  key: 0,
  class: "estate-map-block"
}
const _hoisted_6 = { class: "estate-map-block__description" }
const _hoisted_7 = {
  key: 4,
  class: "wrapper-powered-by"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.estate?._id)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["estate-map", { 'estate-map-flex': $setup.isEmbedded && $setup.isDesktop }])
        }, [
          (!$setup.isEmbedded)
            ? (_openBlock(), _createBlock($setup["HeaderCustomer"], {
                key: 0,
                estate: $setup.estate,
                overAll: $setup.headerOverAll,
                onLogin: $setup.openLoginModal,
                onRegister: $setup.openRegistrationModal,
                onInterest: $setup.onRegister,
                onContact: $setup.onMessage
              }, null, 8, ["estate", "overAll"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass($setup.isEmbedded ? 'container-embed' : 'container')
          }, [
            _createElementVNode("div", _hoisted_1, [
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (!$setup.isEmbedded)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString($setup.estate.title), 1))
                      : _createCommentVNode("", true),
                    false
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: _normalizeClass(["icon-btn", [$setup.getBtnClassByViewType, $setup.isEmbedded && 'embedded-btn', $setup.zoom !== 1 && 'mr-1']]),
                          onClick: $setup.changeView
                        }, _toDisplayString($setup.isDesktop ? ($setup.viewType === "map" ? "View Available Lots" : "map") : ""), 3))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!$setup.isDesktop && !$setup.showStageMap && !$setup.isEmbedded)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: _normalizeClass([$setup.isEmbedded ? 'map-details-embedded' : 'map-details'])
                  }, "Select any available stage to view lots", 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["estate-map-wrapper-map", { 'estate-map-wr-embedded': $setup.isEmbedded && $setup.isDesktop }])
              }, [
                (!$setup.showStageMap && $setup.viewType === 'map')
                  ? (_openBlock(), _createBlock($setup["EstateMap"], {
                      key: 0,
                      role: $setup.UserRoles.CUSTOMER,
                      viewType: $setup.viewType,
                      isEmbedded: $setup.isEmbedded,
                      mapPage: $setup.MapPages.ESTATE_MAP,
                      zoom: $setup.zoom,
                      businessId: $setup.businessId,
                      isWaitlistEnabled: $setup.estate?.isWaitlistEnabled !== false,
                      onChangeView: $setup.changeView,
                      onShowShareMapModal: _cache[0] || (_cache[0] = ($event: any) => ($setup.isOpenedShareMapModal = true)),
                      onUpdateZoom: $setup.updateZoom,
                      onOnRegister: $setup.onRegister,
                      onOnMessage: $setup.onMessage
                    }, null, 8, ["role", "viewType", "isEmbedded", "mapPage", "zoom", "businessId", "isWaitlistEnabled"]))
                  : _createCommentVNode("", true),
                ($setup.showStageMap && $setup.viewType === 'map')
                  ? (_openBlock(), _createBlock($setup["StageMap"], {
                      key: 1,
                      role: $setup.UserRoles.CUSTOMER,
                      isEmbedded: $setup.isEmbedded,
                      mapPage: $setup.MapPages.STAGE_MAP,
                      zoom: $setup.zoom,
                      businessId: $setup.businessId,
                      isWaitlistEnabled: $setup.estate?.isWaitlistEnabled !== false,
                      onChangeView: $setup.changeView,
                      onReserve: _cache[1] || (_cache[1] = ($event: any) => ($setup.onReserve($event))),
                      onUpdateZoom: $setup.updateZoom,
                      onOnRegister: $setup.onRegister,
                      onOnMessage: $setup.onMessage,
                      onOnLotBuilderHover: _cache[2] || (_cache[2] = (value) => ($setup.lotBuilderIconHover = value)),
                      onOnMouseX: _cache[3] || (_cache[3] = (value) => ($setup.mouseX = value)),
                      onOnMouseY: _cache[4] || (_cache[4] = (value) => ($setup.mouseY = value))
                    }, null, 8, ["role", "isEmbedded", "mapPage", "zoom", "businessId", "isWaitlistEnabled"]))
                  : _createCommentVNode("", true),
                ($setup.viewType === 'list' || (!$setup.isDesktop && !$setup.isEmbedded))
                  ? (_openBlock(), _createBlock($setup["StageList"], {
                      key: 2,
                      isEmbedded: $setup.isEmbedded,
                      estate: $setup.estate,
                      viewType: $setup.viewType,
                      mapPage: $setup.MapPages.STAGE_LIST,
                      hideNav: !_ctx.showStage,
                      stageId: $setup.showStageMap,
                      showSoldOutStages: !$setup.isDesktop && !$setup.showStageMap,
                      hideStageRowHeader: !$setup.isDesktop && $setup.showStageMap,
                      onChangeView: $setup.changeView,
                      onReserve: _cache[5] || (_cache[5] = ($event: any) => ($setup.onReserve($event)))
                    }, null, 8, ["isEmbedded", "estate", "viewType", "mapPage", "hideNav", "stageId", "showSoldOutStages", "hideStageRowHeader"]))
                  : _createCommentVNode("", true)
              ], 2),
              ($setup.isEmbedded && !$setup.isDesktop)
                ? (_openBlock(), _createBlock($setup["EstateMapEmbeddedOptions"], {
                    key: 2,
                    estateId: $setup.estateId,
                    onOnMessage: $setup.onMessage
                  }, null, 8, ["estateId"]))
                : _createCommentVNode("", true),
              (!$setup.isEmbedded && !$setup.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    ($setup.estate.isWaitlistEnabled !== false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "estate-map-block__title" }, "Join Waitlist", -1)),
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "estate-map-block__description" }, "Not seeing what you're looking for? Click here to join the waitlist and be informed about future releases.", -1)),
                          _createElementVNode("button", {
                            class: "button primary w-100",
                            onClick: $setup.onRegister
                          }, "Register")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["estate-map-block", { 'w-100': $setup.estate.isWaitlistEnabled === false }])
                    }, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "estate-map-block__title" }, "Submit an enquiry", -1)),
                      _createElementVNode("div", _hoisted_6, "Got a question about " + _toDisplayString($setup.estate.title) + "? Send us a message and a member of our team will get back to you.", 1),
                      _createElementVNode("button", {
                        class: "button primary w-100",
                        onClick: $setup.onMessage
                      }, "Message")
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (!$setup.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createVNode($setup["ReserveLotModal"], {
              isOpen: $setup.showReserveModal,
              lot: $setup.lotForReserve,
              embedded: $setup.isEmbedded,
              "transition-name": $setup.transitionName,
              estate: $setup.estate,
              businessId: $setup.businessId,
              onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.closeReserveModal($event))),
              onToContact: $setup.showContactWithQuestion,
              onReserve: _cache[7] || (_cache[7] = ($event: any) => ($setup.onReserveLot($event))),
              onHold: $setup.onHoldRequest,
              onToRequestQuote: $setup.onRequestQuote,
              onUpdateHeaderOverAll: $setup.updateHeaderOverAll
            }, null, 8, ["isOpen", "lot", "embedded", "transition-name", "estate", "businessId"]),
            _createVNode($setup["InitialHoldModal"], {
              "is-open": $setup.isOpenedInitialHoldModal,
              lot: $setup.lotForReserve,
              businessId: $setup.businessId,
              onClose: $setup.onCloseHoldRequest,
              onSend: $setup.onSendHoldRequest,
              onBack: $setup.backToReserve,
              onToPartnerModal: $setup.onOpenPartnerModal
            }, null, 8, ["is-open", "lot", "businessId"]),
            _createVNode($setup["initialHoldWithPartnerModal"], {
              "is-open": $setup.isOpenedInitialHoldModalWithPartner,
              lot: $setup.lotForReserve,
              businessId: $setup.businessId,
              onClose: $setup.onCloseHoldRequestWithPartner,
              onSend: $setup.onSendHoldRequest,
              onBack: $setup.backToReserve
            }, null, 8, ["is-open", "lot", "businessId"]),
            _createVNode($setup["LoginOrCreateModal"], {
              "is-open": $setup.isOpenedLoginOrCreateModal,
              onClose: $setup.onCloseLoginOrCreateModal,
              onLogin: $setup.onSelectLogin,
              onCreate: $setup.onSelectCreate
            }, null, 8, ["is-open"]),
            _createVNode($setup["LoginModal"], {
              "is-open": $setup.isOpenedLoginModal,
              joining: true,
              "transition-name": $setup.transitionName,
              onClose: $setup.onCloseLoginModal,
              onLogin: $setup.onLogin,
              "login-error": $setup.loginError,
              onJoin: $setup.onJoin,
              onForgotPassword: $setup.onForgotPassword
            }, null, 8, ["is-open", "transition-name", "login-error"]),
            _createVNode($setup["RegistrationModal"], {
              estate: { imgPath: $setup.estate.logoUrl },
              "is-open": $setup.isOpenedRegistrationModal,
              "transition-name": $setup.transitionName,
              onClose: $setup.onCloseRegistrationModal,
              onSignUp: $setup.signUp,
              onLogin: $setup.onLoginFromRegistration,
              message: $setup.registrationMessage
            }, null, 8, ["estate", "is-open", "transition-name", "message"]),
            _createVNode($setup["ContactUsModal"], {
              "is-open": $setup.isOpenedContactUsModal,
              lot: $setup.isQuestionWithLot ? $setup.lotForReserve : null,
              isLoading: $setup.isLoadingContactUsModal,
              onClose: $setup.onCloseContactUsModal,
              onSend: $setup.onSendContactUsModal,
              onBack: $setup.backToReserve
            }, null, 8, ["is-open", "lot", "isLoading"]),
            _createVNode($setup["ResetPasswordModal"], {
              "is-open": $setup.isOpenedResetPasswordModal,
              onOnSend: $setup.onSendInResetPasswordModal,
              onClose: $setup.onCloseResetPasswordModal,
              message: $setup.forgotPasswordMessage
            }, null, 8, ["is-open", "message"]),
            _createVNode($setup["ShareMapModal"], {
              isOpen: $setup.isOpenedShareMapModal,
              estateId: $setup.estateId,
              estateTitle: $setup.estate.title,
              onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.isOpenedShareMapModal = false))
            }, null, 8, ["isOpen", "estateId", "estateTitle"]),
            _createVNode($setup["SuccessInitialHoldModal"], {
              isOpen: $setup.successfulInitialRequestOpen,
              onClose: _cache[9] || (_cache[9] = ($event: any) => ($setup.successfulInitialRequestOpen = false)),
              lot: $setup.lotForReserve
            }, null, 8, ["isOpen", "lot"]),
            ($setup.isOpenedBuilderRequestQuoteModal)
              ? (_openBlock(), _createBlock($setup["BuilderRequestQuoteModal"], {
                  key: 0,
                  isOpen: $setup.isOpenedBuilderRequestQuoteModal,
                  lot: $setup.lotForReserve,
                  estate: $setup.estate,
                  onBack: $setup.backToReserve,
                  onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.isOpenedBuilderRequestQuoteModal = false))
                }, null, 8, ["isOpen", "lot", "estate"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    ($setup.lotBuilderIconHover)
      ? (_openBlock(), _createBlock($setup["InfoWithIcon"], {
          key: 1,
          class: "builder-icon-info-component",
          style: _normalizeStyle({ top: `${$setup.mouseY}px`, left: `${$setup.mouseX}px` }),
          text: 'This lot is eligible for you to build your own home and land package.'
        }, null, 8, ["style"]))
      : _createCommentVNode("", true)
  ]))
}